module.exports = __webpack_public_path__ + "img/harry_potter_05_and_the_order_of_the_phoenix_scan.66f2a749.jpg";